import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
    selector: 'app-grouped-checkbox',
    templateUrl: './grouped-checkbox.component.html',
    styleUrls: ['./grouped-checkbox.component.scss']
})


export class GroupedCheckboxComponent implements OnInit, OnChanges {
    @Input() element: number;
    @Input() selectedElements: number[] = [];

    @Output() selectedElementsChange: EventEmitter<number[]> = new EventEmitter<number[]>();

    state: boolean;

    constructor() { }

    ngOnInit() {
        // this.state = this.selectedElements.indexOf(this.element) != -1;
    }

    ngOnChanges() {
        this.state = this.selectedElements.indexOf(this.element) !== -1;
    }

    changeState() {
        this.state = !this.state;

        if (this.state) {
            this.selectedElements.push(this.element);
            this.selectedElementsChange.emit(this.selectedElements);
        } else {
            const index = this.selectedElements.indexOf(this.element);
            if (index > -1) {
                this.selectedElements.splice(index, 1);
            }
            this.selectedElementsChange.emit(this.selectedElements);
        }
    }
}
